export enum BottomBarThemes {
  white = 'white',
  warning = 'warning',
  midnight = 'midnight',
  charcoal = 'charcoal',
}

export enum BottomBarCtaColors {
  alt = 'alt',
  upgrade = 'upgrade',
  ghost = 'primary',
}

export enum BottomBarCtaVariants {
  solid = 'solid',
  ghost = 'ghost',
  text = 'text',
}
